var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-box",class:{ 'video-card': _vm.videoCard }},[(_vm.boxData.titleImg)?_c('div',{staticClass:"box-header"},[_c('div',{staticClass:"img-wrap"},[_c('img',{attrs:{"src":_vm.boxData.titleImg,"alt":""}})])]):_vm._e(),(_vm.boxData.title)?_c('div',{staticClass:"box-title-content",class:{
      color1: _vm.boxData.color1,
      color2: _vm.boxData.color2,
      videoBox: _vm.boxData.videoBox,
      box2: _vm.boxData.titleImg,
      advantage: _vm.boxData.advantage,
      zh: _vm.$i18n.locale === 'zh' || _vm.$i18n.locale === 'zh-tw',
      ja: _vm.$i18n.locale === 'ja',
      ko: _vm.$i18n.locale === 'ko',
      fr: _vm.$i18n.locale === 'fr',
      es: _vm.$i18n.locale === 'es',
    }},[_vm._v(" "+_vm._s(_vm.boxData.title)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.boxData.title2)+" ")]):_vm._e(),(_vm.boxData.desc)?_c('div',{staticClass:"box-desc-content",class:{
      box2: _vm.boxData.titleImg,
      advantage: _vm.boxData.advantage,
      color1: _vm.boxData.id && _vm.boxData.id !== 2,
      zh: _vm.$i18n.locale === 'zh' || _vm.$i18n.locale === 'zh-tw',
      ja: _vm.$i18n.locale === 'ja',
      ko: _vm.$i18n.locale === 'ko',
      fr: _vm.$i18n.locale === 'fr',
      es: _vm.$i18n.locale === 'es',
    }},[_vm._v(" "+_vm._s(_vm.boxData.desc)+" ")]):_vm._e(),(_vm.boxData.img)?_c('div',{staticClass:"box-img-content",class:{ advantage: _vm.boxData.advantage }},[_c('img',{attrs:{"src":_vm.boxData.img,"alt":""}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }